import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/bulk/soft`;

export const ROUTE: RouteDefinition = `${baseRoute}/bulk/soft`;

export const URL = (): RouteDefinition => `${baseRoute}/bulk/soft`;
